import { render, staticRenderFns } from "./ProductListingsSection.vue?vue&type=template&id=3d6ac887&scoped=true&"
import script from "./ProductListingsSection.vue?vue&type=script&lang=js&"
export * from "./ProductListingsSection.vue?vue&type=script&lang=js&"
import style0 from "./ProductListingsSection.vue?vue&type=style&index=0&id=3d6ac887&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6ac887",
  null
  
)

export default component.exports